import type { MaterialSymbolName } from '@repo/design-system/types/material-symbol-names';
import type { MapDataHeroActionIconCategory } from '@repo/types/maps/map-types';

export const HERO_ACTION_ICON_BY_CATEGORY: Readonly<Record<MapDataHeroActionIconCategory, MaterialSymbolName>> = {
    story_lore: 'menu_book',
    loot_gear: 'swords',
    collectible: 'diamond',
    companion: 'person',
    easter_egg: 'egg',
    combat_boss: 'skull',
};

export function getHeroActionIcon(category: MapDataHeroActionIconCategory): MaterialSymbolName {
    return HERO_ACTION_ICON_BY_CATEGORY[category];
}
